export const getDefaultState = () => {
  return {
    storePickupSlot: null,
    scheduledDeliverySlot: null,
  }
}

export default getDefaultState()
